import { validator } from "LIB/validate-this";
import * as rules from "LIB/validation/rules";
import {
  CITY,
  COUNTRY,
  LINE1,
  LINE2,
  POSTAL_CODE,
  STATE
} from "APP_ROOT/constants";

export default function validate(values) {
  return validator(values, form => {
    form.validate("customer_credit_limit").satisfies(rules.isGreaterThan(0));
    form.validate("vendor_credit_limit").satisfies(rules.isGreaterThan(0));
    form.validateChild("billing_address", billingForm => {
      billingForm
        .validate(LINE1, CITY, STATE, POSTAL_CODE, COUNTRY)
        .satisfies(
          rules.requiredIfAnyDefined(
            LINE1,
            LINE2,
            CITY,
            STATE,
            POSTAL_CODE,
            COUNTRY
          )
        );
    });
  });
}



// WEBPACK FOOTER //
// ./app/modules/companies/components/EditBilling/validate.js